<template>
  	<div class="stores">
		<div style="padding: 10px 0">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>课程管理</el-breadcrumb-item>
				<el-breadcrumb-item>精选合集</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div class="hall-search-list">
			<el-button
				size="small"
				type="primary"
				icon="el-icon-plus"
				@click="add"
				plain
				>创建精选合集</el-button
			>
		</div>
		<div class="main">
			<div class="traingplan">
				<dl v-for="(item, index) in tableData" :key="index" class="traingplan-group">
					<dt>
					<div class="traingplan-img-group">
						<img :src="item.appCoverUrl" />
					</div>
					<p class="title">名称：{{item.title}}</p>
					<p style="display:flex;align-items: center;justify-content: flex-end;padding:0 10px;">
						<el-button size="mini" type="text" icon="el-icon-edit" @click="edit(item.id)" style="padding-right:20px;">编辑</el-button>
						<el-switch
							v-model="item.status == 1 ? true : false"
							active-color="#13ce66"
							inactive-color="#eeeeee"
							active-text="上架"
							inactive-text="下架"
							@change="updatesw(index, item.id, item.status)"
						>
						</el-switch>
					</p>
					</dt>
				</dl>
        </div>
    </div>

  	</div>
</template>

<script>
export default {
  	components: {},
	mounted() {
	    this.init();
	},
  	data() {
    	return {
	      	headers: {
	        	xqiao_token: localStorage.getItem("token") 
	      	},
		    cur:-1,

		    tableData:[],
		    switchvalue:true,
		    sportsKindId:0
    	};
  	},
  	methods: {
	    //初始化表格数据
	    init() { 
	      	//let params = this.searchForm
	      	this.$get("/fideatured/getFideaturedCompilationList")
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
		            this.tableData = res.data.list;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
		        }
	        })
	    },
	    add(){ 
	    	this.$router.push({ path: "/addCollection" });
	    },
	    updatesw(index, id, status){
			if (!id) return this.$message.error("主键错误");
			const loading = this.$loading({ text: "加载中..." });
			const upStatus=status==0?1:0;
	    	this.$post("/fideatured/delFideaturedCompilation", {id,status:upStatus})
              	.then(res => {
              		console.log(res)
                	if (res.code == 0) {
						 this.tableData[index].status = upStatus;
                  		this.$message.success('修改成功');
                	} else {
		                this.$message.error('res.message');
                	}
					loading.close();
              	})
        },
        // 路由跳转
        edit(id){
            this.$router.push({path:'/addCollection', query: {id:id}})
        }
  	}
};
</script>

<style scoped>
.traingplan {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.traingplan .traingplan-group {
  width: 20%;
  padding:10px;
  box-sizing: border-box;
}
.traingplan dt {
  background: #ffffff;
  box-shadow: 0 12px 20px 0 rgba(0,0,0,.2);
  border-radius: 6px;
  overflow: hidden;
  font-size: 0;
}
.traingplan dt:hover{
  cursor: pointer;
  box-shadow:
   1px 1px 8px 4px rgba(0, 0, 0, 0.4);
}
.traingplan dl img {
  width: 100%;
  height: 160px;
  object-fit:cover
}
.traingplan dd {
  margin-top: 5px;
  font-size: 13px;
}
.title{
  font-size: 14px;
  color:#333;
  font-weight: bold;
  padding:8px;
}
.title_bewteen{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.el-switch {
  float: right;
}
.traingplan-img-group{
  position: relative;
}
.traingplan-img-group:hover .traingplan-hover{
  display: flex;
}
.traingplan-hover{
  position: absolute;
  top:0;
  left:0;
  bottom:0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,.6);
  font-size: 16px;
  color:#fff;
}
</style>




// WEBPACK FOOTER //
// src/views/coursesList/collection/list.vue